import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Korean
import koCommon from './ko/common.json';
import koHome from './ko/home.json';
import koProducts from './ko/products.json';
import koSupport from './ko/support.json';
import koContact from './ko/contact.json';
import koCertifications from './ko/certifications.json';

// English
import enCommon from './en/common.json';
import enHome from './en/home.json';
import enProducts from './en/products.json';
import enSupport from './en/support.json';
import enContact from './en/contact.json';
import enCertifications from './en/certifications.json';

// Chinese
import zhCommon from './zh/common.json';
import zhHome from './zh/home.json';
import zhProducts from './zh/products.json';
import zhSupport from './zh/support.json';
import zhContact from './zh/contact.json';
import zhCertifications from './zh/certifications.json';

// Japanese
import jaCommon from './ja/common.json';
import jaHome from './ja/home.json';
import jaProducts from './ja/products.json';
import jaSupport from './ja/support.json';
import jaContact from './ja/contact.json';
import jaCertifications from './ja/certifications.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ko: {
        common: koCommon,
        home: koHome,
        products: koProducts,
        support: koSupport,
        contact: koContact,
        certifications: koCertifications,
      },
      en: {
        common: enCommon,
        home: enHome,
        products: enProducts,
        support: enSupport,
        contact: enContact,
        certifications: enCertifications,
      },
      zh: {
        common: zhCommon,
        home: zhHome,
        products: zhProducts,
        support: zhSupport,
        contact: zhContact,
        certifications: zhCertifications,
      },
      ja: {
        common: jaCommon,
        home: jaHome,
        products: jaProducts,
        support: jaSupport,
        contact: jaContact,
        certifications: jaCertifications,
      },
    },
    fallbackLng: 'ko',
    defaultNS: 'common',
    ns: ['common', 'home', 'products', 'support', 'contact', 'certifications'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'tgcam-i18next-lng',
    },
  });

export default i18n;
